import { z } from "zod";
export const gmailLabelSchema = z.object({
    id: z.string().min(1).max(200),
    name: z.string().min(1),
    type: z.enum(["system", "user"]),
});
export const gmailViewSchema = z.enum(["all", "inbox", "sent", "archived", "label"]);
export const listConnectorGmailLabelsResponseSchema = z.object({
    catalogues: z.array(z.object({
        integrationId: z.string().min(1),
        labels: z.array(gmailLabelSchema),
        syncedAt: z.number().int().nonnegative(),
    })),
});
